import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { socket } from "../config";
import {
  CREATE_NEW_PASSWORD,
  LOGIN,
  LOGOUT,
  PORTAL_LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from "../actions/types";
import * as authApi from "../apis/authApi";

export function* loginWorker(action) {
  try {
    const res = yield call(authApi.login, {
      email: action.email,
      password: action.password,
    });
    if (res.status == "200") {
      console.log(res);
      if (res.data.data.userData.is_new == true) {
        localStorage.setItem("resetToken", res.data.data.access_token);
      } else {
        localStorage.clear();
        socket.emit("connected", res.data.data.userData.id);
        localStorage.setItem("accessToken", res.data.data.access_token);
        localStorage.setItem(
          "is_subscribed",
          res.data.data.userData.is_subscribed
        );
        localStorage.setItem("email", res.data.data.userData.email);
        localStorage.setItem("logo", res.data.data.userData.logo);
        localStorage.setItem("userType", res.data.data.userData.user_type);
        localStorage.setItem(
          "is_subscribed",
          res.data.data.userData.is_subscribed
        );
        localStorage.setItem("userId", res.data.data.userData.id);
        if (res.data.data.userData.user_type !== "vendor") {
          localStorage.setItem(
            "permissions",
            JSON.stringify(res.data.data.userData.vendorSuperUserPermissions)
          );
        }
      }
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* portalLoginWorker(action) {
  try {
    const res = yield call(authApi.portalLoginApi, {
      token: action.token,
    });
    if (res.status == "200") {
      console.log(res, "response data");
      localStorage.clear();
      localStorage.setItem("accessToken", res.data.data.access_token);
      localStorage.setItem("email", res.data.data.userData.email);
      localStorage.setItem("logo", res.data.data.userData.logo);
      localStorage.setItem("userType", res.data.data.userData.user_type);
      localStorage.setItem(
        "is_subscribed",
        res.data.data.userData.is_subscribed
      );
      if (res.data.data.userData.user_type !== "vendor") {
        localStorage.setItem(
          "permissions",
          JSON.stringify(res.data.data.userData.vendorSuperUserPermissions)
        );
      }
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* logoutWorker(action) {
  try {
    const res = yield call(authApi.logoutApi);
    console.log(res);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* createNewPasswordWorker(action) {
  try {
    const res = yield call(authApi.createNewPasswordApi, action.data);
    console.log(res);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* forgotPasswordWorker(action) {
  try {
    const res = yield call(authApi.forgotPasswordApi, action.data);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* resetPasswordWorker(action) {
  try {
    console.log(action.data);
    const res = yield call(authApi.resetPasswordApi, action.data);
    if (res.status == "200") {
      localStorage.clear();
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* watchLoginWorker() {
  yield takeLatest(LOGIN, loginWorker);
}

export function* logoutWatcher() {
  yield takeLatest(LOGOUT, logoutWorker);
}

export function* portalLoginWatcher() {
  yield takeLatest(PORTAL_LOGIN, portalLoginWorker);
}

export function* createNewPasswordWatcher() {
  yield takeLatest(CREATE_NEW_PASSWORD, createNewPasswordWorker);
}

export function* forgotPasswordWatcher() {
  yield takeLatest(FORGOT_PASSWORD, forgotPasswordWorker);
}

export function* resetPasswordWatcher() {
  yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}
